<!-- 运维管理（user） -->
<template>
  <div class="manufacturer-container">
    <div class="main-container">
      <div class="header-container">
        <div class="left">
          <el-select size="small" class="w-180" multiple collapse-tags v-model="search.serviceProvidersCompanyId" placeholder="全部服务公司" clearable>
            <el-option v-for="item in customCompanys" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <el-date-picker type="date" size="small" v-model="search.startTime" placeholder="选择日期" class="w-180  m-l-10"></el-date-picker>
          <div style="color: #000;line-height: 30px;padding: 0px 6px;">-</div>
          <el-date-picker type="date" size="small" v-model="search.endTime" placeholder="选择日期" class="w-180"></el-date-picker>
          <!-- <el-select size="small" placeholder="工单状态" v-model="search.status" class="w-180 m-l-10">
            <el-option v-for="key in operationState" :key="key" :label="operationState[key]" :value="key"></el-option>
          </el-select> -->
          <el-button type="primary" size="small" class="m-l-10" @click="selectClick">查询</el-button>
        </div>
      </div>
      <div class="table-container">
        <nk-table :columns="columns" :data="tableData" :showPage="false">
          <el-table-column label="工单类别" width="80" :align="'center'" slot="type">
            <template slot-scope="scope">
              {{operationType[scope.row.type]}}
            </template>
          </el-table-column>
          <el-table-column label="工单状态" width="100" :align="'center'" slot="state">
            <template slot-scope="scope">
              {{operationState[scope.row.state]}}
            </template>
          </el-table-column>
          <el-table-column label="操作" :align="'center'" fixed="right" width="160">
            <template slot-scope="scope">
              <el-button type="text" @click="showInfo(scope.$index, scope.row)">详情</el-button>
              <el-button type="text" v-if="scope.row.score == null" @click="showScore(scope.$index, scope.row)">评分</el-button>
              <el-button type="text" v-if="scope.row.reportFileResourceId" @click="downloadFile(scope.$index, scope.row)">下载报告</el-button>
            </template>
          </el-table-column>
        </nk-table>
      </div>
      <div class="pagination-container">
        <lt-pagination ref="pagination" :pageTotal="tablePage.pageTotal" :pageSize="tablePage.pageSize" :loadDataFunc="getData" @change="paginationChange"></lt-pagination>
      </div>
    </div>

    <lt-msg-box :visible="infoVisible" @cancel="infoVisible = false" :showFoot="false" :title="'详情'" :width="'800px'">
      <div class="form-container">
        <div class="flex">
          <div class="flex flex-1">
            <div class="info-title">创建人：</div>
            <div class="info-content">{{selectedRow.creatorNickname}}</div>
          </div>
          <div class="flex flex-1">
            <div class="info-title">工单编号：</div>
            <div class="info-content">{{selectedRow.id}}</div>
          </div>
          <div class="flex  flex-1">
            <div class="info-title">工单状态：</div>
            <div class="info-content">{{operationState[ selectedRow.state]}}</div>
          </div>
        </div>
        <div class="title">
          基本信息
        </div>
        <div class="flex">
          <div class="flex-1">
            <div class="flex">
              <div class="info-title">项目编号：</div>
              <div class="info-content">{{selectedRow.contractProjectId}}</div>
            </div>
            <div class="flex">
              <div class="info-title">工单名称：</div>
              <div class="info-content">{{selectedRow.name}}</div>
            </div>
            <div class="flex">
              <div class="info-title">客户名称：</div>
              <div class="info-content">{{selectedRow.clientCompanyName}}</div>
            </div>
            <div class="flex">
              <div class="info-title">关联告警：</div>
              <div class="info-content">{{selectedRow.clientEventRecordId}}</div>
            </div>
          </div>
          <div class="flex-1">
            <div class="flex">
              <div class="info-title">项目名称：</div>
              <div class="info-content">{{selectedRow.contractProjectName}}</div>
            </div>
            <div class="flex">
              <div class="info-title">工单类别：</div>
              <div class="info-content">{{operationType[selectedRow.type]}}</div>
            </div>
            <div class="flex">
              <div class="info-title">基地站点：</div>
              <div class="info-content">{{selectedRow.workBaseName}}</div>
            </div>
            <div class="flex">
              <div class="info-title">创建时间：</div>
              <div class="info-content">{{selectedRow.creatingTime}}</div>
            </div>
          </div>
        </div>
        <div class="flex">
          <div class="info-title">附件：</div>
          <div class="info-content">
            <p v-for="item in selectedRow.attachments" :key="item.id">
              <a href="#" @click.prevent="downloadFile(item.id)">{{item.fileName}}</a>
            </p>
          </div>
        </div>
        <div class="title">
          计划任务
        </div>
        <div class="flex">
          <div class="flex-1">
            <div class="flex">
              <div class="info-title">计划编号：</div>
              <div class="info-content">{{selectedRow.planId}}</div>
            </div>
            <div class="flex">
              <div class="info-title">主要负责人：</div>
              <div class="info-content">{{selectedRow.mainExecutorNickname}}</div>
            </div>
            <div class="flex">
              <div class="info-title">团队成员：</div>
              <div class="info-content">
                <label v-for="item in selectedRow.teamMembers" :key="item.userId">{{item.nickname}}</label>
              </div>
            </div>
          </div>
          <div class="flex-1">
            <div class="flex">
              <div class="info-title">开始时间：</div>
              <div class="info-content">{{selectedRow.startTime}}</div>
            </div>
            <div class="flex">
              <div class="info-title">结束时间：</div>
              <div class="info-content">{{selectedRow.endTime}}</div>
            </div>
          </div>
        </div>
        <div class="flex">
          <div class="info-title">维护设备：</div>
          <div class="info-content">
            <label v-for="item in selectedRow.requireMaintainEquipment" :key="item.id"> {{item.name}}, </label>
          </div>
        </div>
        <div class="flex">
          <div class="info-title">计划描述：</div>
          <div class="info-content">{{selectedRow.describe}}</div>
        </div>

        <div class="title">
          验收记录
        </div>
        <div class="flex">
          <div class="flex-1">
            <div class="flex">
              <div class="info-title">验收时间：</div>
              <div class="info-content">{{selectedRow.stateChangingTime}}</div>
            </div>
            <div class="flex">
              <div class="info-title">评分时间：</div>
              <div class="info-content">{{selectedRow.scoringTime}}</div>
            </div>
          </div>
          <div class="flex-1">
            <div class="flex">
              <div class="info-title">客户评分：</div>
              <div class="info-content">
                <el-rate v-model="selectedRow.score" v-if="selectedRow.score" disabled show-score score-template="{value}分"></el-rate>
                <label v-else>-分</label>
              </div>
            </div>
          </div>
        </div>
        <div class="flex">
          <div class="info-title">客户签名：</div>
          <div class="info-content">
            <div class="img-none" v-if="selectedRow.clientSignatureFileResourceId">
              <img style="height: 450px;transform: rotate(-90deg);" :src="clientSignatureFileBase64Data" alt="" srcset="">
            </div>
            <div v-else class="img-none" style="height:150px">暂无客户签名</div>
          </div>
        </div>
      </div>
    </lt-msg-box>

    <lt-msg-box :visible="scoreVisible" @cancel="scoreVisible = false" @confirm="saveScore" :title="'评分'" :width="'300px'">
      <div class="form-container">
        <div>请对此工单打出对应的评分</div>
        <div style="padding:10px 0px;text-align: center;">
          <el-rate v-model="scoreFrom.score" show-score score-template="{value}分"></el-rate>
        </div>
      </div>
    </lt-msg-box>
  </div>
</template>

<script>
import NkTable from '@/components/common/NkTable.vue'
import api from '../../../../../common/api'
import { toPage } from "@/utils/index";
import LtMsgBox from '@/components/common/LtMsgBox.vue';
import LtPagination from '@/components/common/LtPagination.vue'
import dateTool from '@/utils/dateTool';
import config from '@common/config/index.js'
import { downloadFileByBase64Data, getFileByBase64Data } from '@common/utils/file.js'
export default {
  components: { NkTable, LtMsgBox, LtPagination },
  data () {
    return {
      customCompanys: [],
      operationType: config.operationType,
      operationState: config.operationState,
      search: {
        serviceProvidersCompanyId: [],
        startTime: null,
        endTime: null,
        status: null
      },
      columns: [
        { prop: 'id', width: '160', label: '工单编号', show: true },
        { prop: 'name', label: '任务名称', show: true },
        { slot: 'state', width: '80', label: '工单状态', show: true },
        { prop: 'serviceProviderCompanyName', width: '120', label: '服务公司', show: true },
        // { prop: 'contractId', width: '120', label: '合同编号', show: true },
        // { prop: 'contractName', width: '120', label: '合同名称', show: true },
        { slot: 'type', width: '80', label: '工单类型', show: true },
        { prop: 'startTime', width: '160', label: '开始时间', show: true },
        { prop: 'endTime', width: '160', label: '结束时间', show: true },
      ],
      tableData: [],
      tablePage: {
        offset: 0,
        pageTotal: 10,
        pageSize: 10
      },
      infoVisible: false,
      selectedRow: {},
      scoreVisible: false,
      scoreFrom: {},
      clientSignatureFileBase64Data: null,

    }
  },
  mounted () {
    this.load()
  },
  methods: {
    load () {
      let vm = this
      api.electricOperations.listElectricOperationsCompaniesForClient(0, null, null).then(res => {
        let data = []
        if (res.success) {
          data = res.data
        }
        vm.customCompanys = data
        vm.getData()
      })
    },
    selectClick () {
      let vm = this
      vm.tablePage = {
        offset: 0,
        pageTotal: 10,
        pageSize: 10
      }
      vm.getData()
      vm.$refs['pagination'].init()
    },
    getData () {
      let vm = this
      let startTime = null
      let endTime = null
      let serviceProvidersCompanyId = []
      let states = [7]

      if (vm.search.startTime) {
        startTime = dateTool.format(vm.search.startTime, "yyyy-MM-dd hh:mm:ss")
      }
      if (vm.search.endTime) {
        endTime = dateTool.format(vm.search.endTime, "yyyy-MM-dd hh:mm:ss")
      }
      serviceProvidersCompanyId = vm.search.serviceProvidersCompanyId
      // 默认limit 为  pageTotal * pageSize + 1
      const limit = vm.tablePage.pageSize * vm.tablePage.pageTotal + 1
      api.electricOperations.listElectricOperationsWorkOrdersForClient(0, null, startTime, endTime, serviceProvidersCompanyId, states, vm.tablePage.offset, limit).then(res => {
        let allTableData = []
        if (res.data) {
          allTableData = res.data
        }
        vm.tablePage.offset += allTableData.length
        vm.$refs['pagination'].setPageData(allTableData)
      })
    },
    paginationChange (data) {
      this.tableData = data
    },
    showInfo (index, row) {
      if (row.clientSignatureFileResourceId) {
        this.getResourceImg(row.clientSignatureFileResourceId, "clientSignatureFileBase64Data")
      }
      this.selectedRow = JSON.parse(JSON.stringify(row))
      this.infoVisible = true
    },
    downloadFile (reportFileResourceId) {
      let vm = this
      if (!reportFileResourceId) {
        vm.$message("该工单暂无报告")
      }
      api.file.pullCompanySmallFile(reportFileResourceId).then(res => {
        if (res.success) {
          downloadFileByBase64Data(res.data.fileName, res.data.data, res.data.fileType)
        }
      })
    },
    getResourceImg (resourceId, resourceName) {
      let vm = this
      api.file.pullCompanySmallFile(resourceId).then(res => {
        let base64Data = ''
        if (res.success) {
          base64Data = getFileByBase64Data(res.data.data, res.data.fileType)
        }
        vm[resourceName] = base64Data
        console.log(vm[resourceName])
      })
    },
    showScore (index, row) {
      let vm = this
      vm.scoreFrom = {
        id: row.id,
        score: 0
      }
      vm.scoreVisible = true
    },
    saveScore () {
      let vm = this
      const { id, score } = vm.scoreFrom
      api.electricOperations.scoreElectricOperationsWorkOrder(id, score).then(res => {
        if (res.success) {
          vm.$message("评分成功！")
          vm.scoreVisible = false
          vm.getData(vm.tablePage.pageIndex)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.manufacturer-container {
  width: 100%;
  height: 100%;
  padding: 14px;
  box-sizing: border-box;
  .main-container {
    width: 100%;
    height: 100%;
    padding: 14px;
    box-sizing: border-box;
    background: #fff;
    display: flex;
    flex-flow: column;
    .header-container {
      display: flex;
      .left {
        display: flex;
        flex: 1;
        overflow: hidden;
      }
    }
    .table-container {
      flex: 1;
      overflow: hidden;
      margin-top: 10px;
    }
    .pagination-container {
      flex: 0 0 32px;
      padding-top: 14px;
      text-align: right;
    }
  }
}
.form-container {
  padding: 0px 14px;
}
.w-180 {
  width: 180px;
}
.m-l-10 {
  margin-left: 10px;
}
.m-t-10 {
  margin-left: 10px;
}
.info-title {
  color: #494b4d;
  font-size: 14px;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 112px;
  flex: 0 0 80px;
  text-align: right;
}
.info-content {
  color: #7a7d80;
  font-size: 14px;
  flex: 1;
}
.flex {
  display: flex;
  padding: 4px 0px;
}
.img-none {
  width: 100%;
  height: 100%;
  color: rgb(192, 196, 204);
  background: #fff;
  line-height: 150px;
  text-align: center;
  font-size: 20px;
}
.flex-1 {
  flex: 1;
}
.title {
  margin-top: 10px;
  color: #4a90e2;
  background: #d4e1f4;
  padding: 6px 10px;
}
</style>